import { ModuleWithProviders } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import {ProfileComponent} from "./profile.component";
import {AddressesComponent} from "../components/addresses/addresses.component";
import {OrdersComponent} from "./orders/orders.component";
import {DetailsComponent} from "./orders/details/details.component";
import {UserProfileComponent} from "./user-profile/user-profile.component";

/**
 * Created by vikas on 15-01-2025.
 */
const router: Routes = [
  {
    path: 'profile',
    //component: ProfileComponent,
    children: [
      { path: '', component: ProfileComponent, data: { title: "Smart Dukaan" } },
      { path: 'edit', component: ProfileComponent, data: { title: "Smart Dukaan" } },
      { path: 'address', component: AddressesComponent, data: { title: "Smart Dukaan" } },
      { path: 'orders', component: OrdersComponent, data: { title: "Smart Dukaan" } },
      { path: 'orders/:id', component: DetailsComponent, data: { title: "Smart Dukaan" } },
      { path: 'info', component: UserProfileComponent, data: { title: "Smart Dukaan" } },
    ]
  }
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(router);
